// extracted by mini-css-extract-plugin
export default {"sortSelector":"sortSelectorComponent_sortSelector__rD+AV","selector":"sortSelectorComponent_selector__sWPSk"};